"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("./store");
var VuexActionTracker = /** @class */ (function () {
    function VuexActionTracker(config) {
        this.config = config;
    }
    VuexActionTracker.prototype.install = function (Vue, store) {
        if (!store) {
            throw new Error("Please provide vuex store.");
        }
        this._Vue = Vue;
        this._store = store;
        this.overrideDispatch();
        store.registerModule(["vuexActionTracker"], new store_1.default(this.config));
    };
    VuexActionTracker.prototype.overrideDispatch = function () {
        var _this = this;
        var dispatch = this._store.dispatch;
        this._store.dispatch = function (type, payload, options) {
            _this.setActive(type, payload, options);
            return dispatch(type, payload, options).then(function (response) {
                _this.setInactive(type, payload, options);
                return response;
            }, function (error) {
                _this.setInactive(type, payload, options);
                throw error;
            });
        };
    };
    VuexActionTracker.prototype.setActive = function (type, payload, options) {
        this._store.commit("vuexActionTracker/setActive", {
            type: type,
            payload: payload,
            options: options
        }, { root: true });
    };
    VuexActionTracker.prototype.setInactive = function (type, payload, options) {
        this._store.commit("vuexActionTracker/setInActive", {
            type: type,
            payload: payload,
            options: options
        }, { root: true });
    };
    return VuexActionTracker;
}());
exports.default = VuexActionTracker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSxpQ0FBNkM7QUFHN0M7SUFTRSwyQkFBWSxNQUFPO1FBQ2pCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO0lBQ3ZCLENBQUM7SUFFTSxtQ0FBTyxHQUFkLFVBQWUsR0FBbUIsRUFBRSxLQUFpQjtRQUNuRCxJQUFJLENBQUMsS0FBSyxFQUFFO1lBQ1YsTUFBTSxJQUFJLEtBQUssQ0FBQyw0QkFBNEIsQ0FBQyxDQUFDO1NBQy9DO1FBRUQsSUFBSSxDQUFDLElBQUksR0FBRyxHQUFHLENBQUM7UUFDaEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxLQUFLLENBQUM7UUFFcEIsSUFBSSxDQUFDLGdCQUFnQixFQUFFLENBQUM7UUFFeEIsS0FBSyxDQUFDLGNBQWMsQ0FDbEIsQ0FBQyxtQkFBbUIsQ0FBQyxFQUNyQixJQUFJLGVBQXNCLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUN4QyxDQUFDO0lBQ0osQ0FBQztJQUVPLDRDQUFnQixHQUF4QjtRQUFBLGlCQWVDO1FBZEMsSUFBSSxRQUFRLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUM7UUFDcEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxRQUFRLEdBQUcsVUFBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQVE7WUFDN0MsS0FBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO1lBQ3ZDLE9BQU8sUUFBUSxDQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUMsSUFBSSxDQUMxQyxVQUFBLFFBQVE7Z0JBQ04sS0FBSSxDQUFDLFdBQVcsQ0FBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO2dCQUN6QyxPQUFPLFFBQVEsQ0FBQztZQUNsQixDQUFDLEVBQ0QsVUFBQSxLQUFLO2dCQUNILEtBQUksQ0FBQyxXQUFXLENBQUMsSUFBSSxFQUFFLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQztnQkFDekMsTUFBTSxLQUFLLENBQUM7WUFDZCxDQUFDLENBQ0YsQ0FBQztRQUNKLENBQUMsQ0FBQztJQUNKLENBQUM7SUFFTyxxQ0FBUyxHQUFqQixVQUFrQixJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU87UUFDdEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQ2hCLDZCQUE2QixFQUM3QjtZQUNFLElBQUksTUFBQTtZQUNKLE9BQU8sU0FBQTtZQUNQLE9BQU8sU0FBQTtTQUNSLEVBQ0QsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLENBQ2YsQ0FBQztJQUNKLENBQUM7SUFFTyx1Q0FBVyxHQUFuQixVQUFvQixJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU87UUFDeEMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQ2hCLCtCQUErQixFQUMvQjtZQUNFLElBQUksTUFBQTtZQUNKLE9BQU8sU0FBQTtZQUNQLE9BQU8sU0FBQTtTQUNSLEVBQ0QsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLENBQ2YsQ0FBQztJQUNKLENBQUM7SUFDSCx3QkFBQztBQUFELENBQUMsQUFyRUQsSUFxRUMifQ==